module.exports = "/_next/static/images/jp-e2d838a26303d452abf1a36a833858ab.svg";